import { render, staticRenderFns } from "./UserAddPage.vue?vue&type=template&id=7bde237a&"
import script from "./UserAddPage.vue?vue&type=script&lang=js&"
export * from "./UserAddPage.vue?vue&type=script&lang=js&"
import style0 from "./UserAddPage.vue?vue&type=style&index=0&id=7bde237a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports